const defaultLayout = {
  self: {
    logo: {
      default: "/media/cirx/logos/cx-logo.svg",
      png: "/media/cirx/logos/cx-logo.png",
    },
  },
  colors: {
    theme: {
      base: {
        primary: "#2ed678",
      },
    },
  },
  header: {
    user: {
      display: true,
    },
    menu: {
      self: {
        display: true,
      },
    },
  },
  subheader: {
    display: true,
  },
  content: {
    width: "fixed",
  },
  aside: {
    self: {
      display: true,
    },
  },
};

export default defaultLayout;
